"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _element = require("@wordpress/element");

var _i18n = require("@wordpress/i18n");

var _blockEditor = require("@wordpress/block-editor");

var _components = require("@wordpress/components");

/**
 * WordPress dependencies
 */
const OrderedListSettings = _ref => {
  let {
    setAttributes,
    reversed,
    start
  } = _ref;
  return (0, _element.createElement)(_blockEditor.InspectorControls, null, (0, _element.createElement)(_components.PanelBody, {
    title: (0, _i18n.__)('Ordered list settings')
  }, (0, _element.createElement)(_components.TextControl, {
    label: (0, _i18n.__)('Start value'),
    type: "number",
    onChange: value => {
      const int = parseInt(value, 10);
      setAttributes({
        // It should be possible to unset the value,
        // e.g. with an empty string.
        start: isNaN(int) ? undefined : int
      });
    },
    value: Number.isInteger(start) ? start.toString(10) : '',
    step: "1"
  }), (0, _element.createElement)(_components.ToggleControl, {
    label: (0, _i18n.__)('Reverse list numbering'),
    checked: reversed || false,
    onChange: value => {
      setAttributes({
        // Unset the attribute if not reversed.
        reversed: value || undefined
      });
    }
  })));
};

var _default = OrderedListSettings;
exports.default = _default;
//# sourceMappingURL=ordered-list-settings.js.map